<script setup>
import VueCaptchaSwitcher from 'vue-captcha-switcher';
import { useForm } from 'vee-validate';
const { loggedIn, user, fetch: refreshSession } = useUserSession();
const display = useDisplay();
const useDialog = useDialogStore();
const { progress, isLoading, start, finish, clear } = useLoadingIndicator({
    duration: 2000,
    throttle: 200,
    estimatedProgress: (duration, elapsed) => (2 / Math.PI * 100) * Math.atan(elapsed / duration * 100 / 50)
});
const variant = computed( () =>{return (display.mobile.value || display.smAndDown.value) ? "flat": "elevated"});
const normalLoading = computed(() => { return loading.value && loginType == 'NORMAL' });
const guestLoading = computed( ()=>{return loading.value && loginType =='GUEST'});
const from = ref();
let loginType = "";
const loading = ref(false);
const hidePwd = ref(true);
const { defineField, handleSubmit, resetForm } = useForm({
  validationSchema: useValidationSchema.loginSchema(),
});
const vuetifyConfig = (state) => ({
  props: {
    'error-messages': state.errors,
  },
});
const [email, emailProps] = defineField('email', vuetifyConfig);
const [pwd, pwdProps] = defineField('pwd', vuetifyConfig);
const guestLogin = () =>{
  const v = {type: loginType ='GUEST' }
  doLogin(v)
}
const onSubmit = handleSubmit((values) => {
  let v = {account: values.email, pwd: useCrypto.encrypt(values.pwd), type: loginType ='NORMAL' };
  doLogin(v);
});
const doLogin = async(v) => {
  loading.value = true;
  start();
  const {data, error, status} = await useAuth.login(v);
  if (error.value)
    useDialog.error(error.value);
  if (data.value) {
    if (loginType == 'NORMAL')
      await saveCredentials();
    await refreshSession();
    await navigateTo('/home');
  }
  finish();
  loading.value = false;
}
const saveCredentials = async() =>{
  const cred = new PasswordCredential({
    id: email.value,
    name: email.value,
    password: pwd.value
  })
  navigator.credentials
    .store(cred)
    .then((data) => {
    })
    .catch((error) => {
    });
}
</script>
<template>
  <div>
    <v-card width="380" class="justify-center" :variant="variant">
      <v-img class="diagram rounded bg-white d-none d-sm-block" src="/diagram/biz-min.svg" lazy-src="/icon/loading.svg">
        <template v-slot:placeholder>
          <v-row align="center" class="fill-height ma-0" justify="center">
            <v-progress-circular color="grey-lighten-5" indeterminate></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <v-card-title class="ml-2">用戶登錄</v-card-title>
      <v-card-text class="ps-5 pb-5 position-relative">
        <div class="d-flex align-center justify-center mb-2">
          <div>沒有帳號嗎？</div>
          <v-btn variant="text" color="info" size="large" @click="navigateTo('/register')">點我註冊</v-btn>
        </div>
        <v-form id="loginForm" ref="form" @submit.prevent="onSubmit" class="mt-2 loginForm">
          <v-text-field id="email" name="email" variant="outlined" density="compact" label="電子郵件" clearable class="mt-2"
            prepend-inner-icon="mdi-email" counter="100" v-model="email" v-bind="emailProps" autocomplete="current-password" :disabled="loading"></v-text-field>            
          <v-text-field id="pwd" name="pwd" variant="outlined" density="compact" label="密碼" class="mt-2"
            prepend-inner-icon="mdi-lock-outline" :append-inner-icon="hidePwd ?'mdi-eye':'mdi-eye-off'" autocomplete="current-password" 
            :type="hidePwd?'password':'text'" counter="20" v-model="pwd" v-bind="pwdProps" @click:append-inner="hidePwd = !hidePwd" :disabled="loading"></v-text-field>                   
          <v-btn color="primary" block class="mt-5" size="large" type="submit" :loading="normalLoading"
            :disabled="guestLoading">登入</v-btn>
        </v-form>
        <div class="mt-3"></div>
        <div class="d-flex justify-center mt-5">
          <v-btn variant="tonal" color="primary" size="default" @click="guestLogin" :loading="guestLoading"
            :disabled="normalLoading">訪客登入</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <app-dialog/>
  </div>
</template>

<style scoped>
.loginForm {
  .v-text-field .v-field--active input {
    font-weight: 300;
  }
}
</style>